import { Component, computed, input } from '@angular/core';

import { CmsTarget, CmsTaxonomy, CmsTaxonomyGeneral } from '@fcom/core-api';

@Component({
  selector: 'fin-link-block',
  styleUrls: ['./link-block.component.scss'],
  templateUrl: './link-block.component.html',
  standalone: false,
})
export class LinkBlockComponent {
  teaserTitle = input<string>();
  target = input<CmsTarget>();
  cmsTags = input<Array<CmsTaxonomy | string>>([]);

  isBlackFriday = computed(() => {
    return this.cmsTags().includes(CmsTaxonomyGeneral.BLACK_FRIDAY);
  });
}
